module.exports = __webpack_public_path__ + "static/media/5.6f5a9b34.jpeg";